import { serviceProvider } from "../../../../comun/provider/ServiceProvider";
import { TareaEjecucionResponse } from "../../../../modulos/rastro/response/TareaEjecucionResponse";
import { DiaTareaEjecucionesBucket } from "../../../../modulos/rastro/services/TareaEjecucionGetYearGroupListByFincaIdService";
import { formatFechaCorta } from "../../../../utils/fechaUtils";
import { BaseFullScreenModalRender } from "../../../base/modal/BaseFullScreenModalRender";
import { IConnectRender } from "../../../definitions/IConnectRender";
import { TareaEjecucionMapRender } from "../map/TareaEjecucionMapRender";

/** Modal a pantalla completa con el mapa de UNA ejecución de tarea: los lotes
 *  de la finca más los puntos y líneas de esa ejecución, sin el resto de las
 *  del día.
 *
 *  Reusa `TareaEjecucionMapRender` tal cual (sin modificarlo): recibe el día
 *  completo y apaga las demás ejecuciones, en vez de armar un balde de una
 *  sola. Es a propósito — `colorDeEjecucion` es posicional dentro del día, así
 *  que con un balde de un item la ejecución cambiaría de color respecto al que
 *  muestra el sidebar. */
export class TareaEjecucionFullScreenModalRender extends BaseFullScreenModalRender {
  /**
   * @param _dia       Día al que pertenece la ejecución (fija los colores).
   * @param _ejecucion Ejecución a mostrar sola en el mapa.
   */
  constructor(
    private readonly _dia: DiaTareaEjecucionesBucket,
    private readonly _ejecucion: TareaEjecucionResponse,
  ) {
    super();
  }

  protected readonly elementId = "tareaEjecucionFullScreenModal";

  /** Nombre de la tarea asignada, o "Sin asignar". */
  protected get title(): string {
    return this._ejecucion.tareaNombre ?? "Sin asignar";
  }

  /** Finca · GPS Tracker · fecha de la ejecución. */
  protected get subtitle(): string {
    const finca = serviceProvider.getFincaSelectedService().getRequired();
    return `${finca.nombreFinca} · GPS Tracker #${this._ejecucion.gpsTrackerNumero} · ${formatFechaCorta(this._ejecucion.fechaInicio)}`;
  }

  /** Mapa del día con todas las demás ejecuciones apagadas. Se puede llamar
   *  `setDia`/`toggleEjecucion` antes de `connect()`: el mapa Leaflet se crea
   *  async y `setOnMapInitializeEnd` redibuja lo que quedó pendiente. */
  protected getContent(): IConnectRender {
    const mapRender = new TareaEjecucionMapRender();
    mapRender.setDia(this._dia);
    for (const otra of this._dia.ejecuciones) {
      if (otra.id === this._ejecucion.id) continue;
      mapRender.toggleEjecucion(otra.id, false);
    }
    return mapRender;
  }
}
